import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

interface Props {
  title: string;
  id: string;
  body: React.ReactNode;
  defaultExpand: boolean;
  setExpandToState: (id: string, state: boolean) => void;
}

export default function AccordionDropdown({
  title,
  body,
  id,
  defaultExpand,
  setExpandToState,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpand);

  const handleChange = () => {
    setExpanded(!expanded);
    setExpandToState(`${id}Expand`, !expanded);
  };
  return (
    <Accordion
      defaultExpanded={defaultExpand}
      onChange={handleChange}
      expanded={expanded}
      sx={{
        "width": "100%",
        "boxShadow": "none",
        "borderBottom": "1px solid #acc8df",
        "& .MuiAccordionSummary-expandIcon": {
          paddingTop: 0,
          paddingBottom: 0,
          height: "1rem",
        },
      }}
      square={true}
    >
      <AccordionSummary
        sx={(theme) => ({
          "paddingX": 0,
          "paddingY": 0.5,
          "width": "100%",
          "backgroundColor": theme.palette.secondary.main,
          "minHeight": "0",
          "&.Mui-expanded": {
            minHeight: "0",
          },
          "& > .MuiAccordionSummary-content": {
            "margin": 0,
            "& h4": {
              margin: 0,
            },
            "&.Mui-expanded": {
              margin: 0,
            },
          },
          "&.Mui-focusVisible": {
            "backgroundColor": theme.palette.secondary.main,
            "& > .MuiAccordionSummary-expandIconWrapper": {
              backgroundColor: "rgba(0, 0, 0, 0.08)",
            },
          },
        })}
        aria-label={`Toggle ${title?.toLowerCase()} panel visibility`}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <Typography
          variant="h4"
          sx={{
            lineHeight: "1rem",
            fontWeight: 700,
            paddingTop: 2,
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={(theme) => ({
          "backgroundColor": theme.palette.secondary.main,
          "padding": "0rem 0rem .5rem 0rem",
          "display": "block",
          "& > div:last-child": { paddingBottom: 0 },
        })}
      >
        {body}
      </AccordionDetails>
    </Accordion>
  );
}
